import Vue from 'vue'
import game from './game.vue'
import '../base/common'

new Vue({
  data() {
    return {
      state: {
        taskList:[],
        userInfo:{},
        authInfo:{},
        brandInfo:{},
        isShowContact:false,
        drawResult:{
          first:{
            winners:[],
            choose:[]
          },
          second:{
            winners:[],
            choose:[]
          },
          third:{
            winners:[],
            choose:[]
          }
        },
        teams:{
          first:{
            list:[]
          },
          second:{
            list:[]
          },
          third:{
            list:[]
          }
        },
        city:{},
        couponList:[],
        prizeList:[]
      }
    }
  },
  created() {
    Vue.prototype.$state = this.state
  },
  render: h => h(game)
}).$mount('#app')
